import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  common_loading: false,
  user_details: null,
  user: null,
  refresh_token_metadata: null
};

export const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setCommonLoading: (state, action) => {
      state.common_loading = action.payload;
    },
    setUserDetails: (state, action) => {
      state.user_details_loading = action.payload;
    },
    setUserData: (state, action) => {
      state.user = action.payload;
    },
    onLogout: (state, action) => {
      state.user = null;
    },
    setRefreshTokenMetadata: (state, action) => {
      state.refresh_token_metadata = action.payload;
    },
  },
});

export const { setCommonLoading, setUserDetails, setUserData, onLogout, setRefreshTokenMetadata } = commonSlice.actions;

export default commonSlice.reducer;
